import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-share-options',
  templateUrl: './share-options.component.html',
  styleUrls: ['./share-options.component.scss'],
})
export class ShareOptionsComponent {
  @Input() postUrl: string;
  @Input() postTitle: string;
  @Input() postText: string;
  @Input() onOptionSelected: (option: string) => void;

  shareOptions = [
    {
      id: 'copy',
      label: 'Copy Link',
      icon: 'copy-outline',
    },
    {
      id: 'facebook',
      label: 'Facebook',
      icon: 'logo-facebook',
    },
    {
      id: 'twitter',
      label: 'Twitter',
      icon: 'logo-twitter',
    },
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      icon: 'logo-whatsapp',
    },
    {
      id: 'email',
      label: 'Email',
      icon: 'mail-outline',
    },
    {
      id: 'native',
      label: 'More Options',
      icon: 'share-outline',
    },
  ];

  selectOption(optionId: string) {
    if (this.onOptionSelected) {
      this.onOptionSelected(optionId);
    }
  }
}

